module.exports = __webpack_public_path__ + "img/icon-grid-with-hero-text.c64da2dc.webp";